import {Base} from "@/dto/Base";

export class BpmToDoDoneDto {
    public static url='/bpm'
    public static async getBpmToDoDone(a: string): Promise<any>{
        const response = await  Base.getData(this.url+'/getBpmTo?phoneNumber='+a) as any
        return  response
    }
}
